
export const LOCAL_STORAGE_MAIN_BRANCH_ID = "_DISPATCH_MAIN_BRANCH_ID_"
export const LOCAL_STORAGE_ENTERED_TIME = "_DISPATCH_ENTERED_TIME_"

export const LOCAL_STORAGE_ORIGINAL_SIGN_LIST="_DISPATCH_ORIGINAL_SIGN_LIST_"
